<div *ngIf="steps.table" class="p-3">
  <div style="width: 100%; text-align: -webkit-right; margin: 10px;">
    <button
      class="primary buttonStylePrimary"
      (click)="addCustomerBenefits()">
      Agregar Plan
    </button>
  </div>

  <div class="row" style="width: 100%;">
    <div class="col-2">
      <p class="pTableTitle">Imagen</p>
    </div>
    <div class="col-2">
      <p class="pTableTitle">Nombre</p>
    </div>
    <div class="col-2">
      <p class="pTableTitle">Teléfono</p>
    </div>
    <div class="col-2">
      <p class="pTableTitle">Periodicidad</p>
    </div>
    <div class="col-1">
      <p class="pTableTitle">N° Cargas</p>
    </div>
    <div class="col-1">
      <p class="pTableTitle">Tipo</p>
    </div>
    <div class="col-2">
      <p class="pTableTitle">Acción</p>
    </div>
  </div>

  <hr>

  <ng-container *ngFor="let cBenefit of cBenefits">
    <div class="row" style="width: 100%;">
      <div class="col-2">
        <ng-container *ngIf="cBenefit.cus_ben_image">
          <img [src]="cBenefit.cus_ben_image" width="100%">
        </ng-container>
        <ng-container *ngIf="!cBenefit.cus_ben_image">
          <p class="pTableNotInfo">No tiene imagen</p>
        </ng-container>
      </div>

      <div class="col-2">
        <ng-container *ngIf="cBenefit.cus_ben_name">
          <p class="pTableInfo">{{ cBenefit.cus_ben_name }}</p>
        </ng-container>
        <ng-container *ngIf="!cBenefit.cus_ben_name">
          <p class="pTableNotInfo">No tiene</p>
        </ng-container>
      </div>

      <div class="col-2">
        <ng-container *ngIf="cBenefit.cus_ben_phone">
          <p class="pTableInfo">{{ cBenefit.cus_ben_phone }}</p>
        </ng-container>
        <ng-container *ngIf="!cBenefit.cus_ben_phone">
          <p class="pTableNotInfo">No tiene</p>
        </ng-container>
      </div>

      <div class="col-2">
        <ng-container *ngIf="cBenefit.cus_ben_typ_name">
          <p class="pTableInfo">{{ cBenefit.cus_ben_typ_name }}</p>
        </ng-container>
        <ng-container *ngIf="!cBenefit.cus_ben_typ_name">
          <p class="pTableNotInfo">No tiene</p>
        </ng-container>
      </div>

      <div class="col-1">
        <ng-container *ngIf="cBenefit.cus_ben_qty_beneficiaries !== null && cBenefit.cus_ben_qty_beneficiaries !== undefined && cBenefit.cus_ben_qty_beneficiaries !== ''">
          <p class="pTableInfo">{{ cBenefit.cus_ben_qty_beneficiaries }}</p>
        </ng-container>
        <ng-container *ngIf="cBenefit.cus_ben_qty_beneficiaries === null || cBenefit.cus_ben_qty_beneficiaries === undefined || cBenefit.cus_ben_qty_beneficiaries === ''">
          <p class="pTableNotInfo">Por base</p>
        </ng-container>
      </div>

      <div class="col-1">
        <ng-container *ngIf="cBenefit.cus_ben_particular">
          <p class="pTableInfo">Particular</p>
        </ng-container>
        <ng-container *ngIf="!cBenefit.cus_ben_particular">
          <p class="pTableNotInfo">Empresarial</p>
        </ng-container>
      </div>

      <div class="col-2" style="text-align: center;">
        <button
          type="button"
          class="btn btn-secondary actionButton"
          (click)="deleteCustomerBenefits(cBenefit)">
          <mat-icon>delete</mat-icon>
        </button>

        <button
          type="button"
          class="btn btn-secondary actionButton"
          (click)="editCustomerBenefits(cBenefit)">
          <mat-icon>edit</mat-icon>
        </button>

        <button
          type="button"
          class="btn btn-secondary actionButton"
          (click)="seeDetails(cBenefit)">
          <mat-icon>info</mat-icon>
        </button>
      </div>
    </div>
    <hr>
  </ng-container>
</div>

<!-- ===================================================== -->
<!-- AGREGAR PLAN -->
<!-- ===================================================== -->
<div *ngIf="steps.add" class="plan-form-wrapper">
  <form [formGroup]="addPlanForm" (ngSubmit)="confirmAdd()" novalidate>
    <div class="plan-form-content">
      <div class="plan-form-main">
        <div class="plan-form-title-box">
          <h2 class="plan-form-title">Creación de plan</h2>
          <p class="plan-form-subtitle">
            Los campos marcados con <span class="plan-required">*</span> son obligatorios.
          </p>
        </div>

        <!-- 1. Información general -->
        <div class="plan-section">
          <div class="plan-section-header">
            <p class="plan-section-title">
              <span class="plan-section-number">1</span>
              Información general
            </p>
          </div>

          <div class="row">
            <div class="col-lg-3 col-12 mb-3">
              <label class="plan-label">Nombre <span class="plan-required">*</span></label>
              <input
                type="text"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_name', addFormSubmitted)"
                placeholder="Ej: Plan Familiar Telemedicina"
                formControlName="cus_ben_name">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_name', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_name') }}
              </div>
            </div>

            <div class="col-lg-3 col-12 mb-3">
              <label class="plan-label">Cliente <span class="plan-required">*</span></label>
              <select
                class="plan-select"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_cus_id', addFormSubmitted)"
                formControlName="cus_ben_cus_id">
                <option value="">Seleccione cliente</option>
                <option
                  *ngFor="let customer of customers"
                  [value]="customer.cus_id">
                  {{ customer.cus_name }}
                </option>
              </select>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_cus_id', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_cus_id') }}
              </div>
            </div>

            <div class="col-lg-3 col-12 mb-3">
              <label class="plan-label">Periodicidad <span class="plan-required">*</span></label>
              <select
                class="plan-select"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_cus_ben_typ_id', addFormSubmitted)"
                formControlName="cus_ben_cus_ben_typ_id">
                <option value="">Seleccione periodicidad</option>
                <option
                  *ngFor="let benType of cBenefitsTypes"
                  [value]="benType.cus_ben_typ_id">
                  {{ benType.cus_ben_typ_name }}
                </option>
              </select>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_cus_ben_typ_id', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_cus_ben_typ_id') }}
              </div>
            </div>

            <div class="col-lg-3 col-12 mb-3">
              <label class="plan-label">Suscripción <span class="plan-required">*</span></label>
              <select
                class="plan-select"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_is_suscription', addFormSubmitted)"
                formControlName="cus_ben_is_suscription">
                <option [ngValue]="null">Seleccione opción</option>
                <option [ngValue]="true">Sí</option>
                <option [ngValue]="false">No</option>
              </select>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_is_suscription', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_is_suscription') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Tipo <span class="plan-required">*</span></label>
              <select
                class="plan-select"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_particular', addFormSubmitted)"
                formControlName="cus_ben_particular">
                <option [ngValue]="null">Seleccione tipo</option>
                <option [ngValue]="true">Particular</option>
                <option [ngValue]="false">Empresarial</option>
              </select>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_particular', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_particular') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">
                N° cargas <span class="plan-required">*</span>
                <mat-icon title="Ingrese 0 si el plan no permite cargas.">error_outline</mat-icon>
              </label>
              <input
                type="number"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_qty_beneficiaries', addFormSubmitted)"
                placeholder="Ej: 2"
                min="0"
                formControlName="cus_ben_qty_beneficiaries">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_qty_beneficiaries', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_qty_beneficiaries') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Código <span class="plan-required">*</span></label>
              <input
                type="text"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_code', addFormSubmitted)"
                placeholder="Ej: PTD001"
                formControlName="cus_ben_code">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_code', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_code') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Teléfono <span class="plan-required">*</span></label>
              <input
                type="text"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_phone', addFormSubmitted)"
                placeholder="Ej: +56 9 1234 5678"
                formControlName="cus_ben_phone">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_phone', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_phone') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Base informada <span class="plan-required">*</span></label>
              <select
                class="plan-select"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_base_informada', addFormSubmitted)"
                formControlName="cus_ben_base_informada">
                <option [ngValue]="null">Seleccione opción</option>
                <option [ngValue]="true">Sí</option>
                <option [ngValue]="false">No</option>
              </select>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_base_informada', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_base_informada') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Email <span class="plan-required">*</span></label>
              <input
                type="email"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_mail_contact', addFormSubmitted)"
                placeholder="plan@almamedis.cl"
                formControlName="cus_ben_mail_contact">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_mail_contact', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_mail_contact') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">
                Orden <span class="plan-required">*</span>
                <mat-icon title="Número de orden del plan">error_outline</mat-icon>
              </label>
              <input
                type="number"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_order', addFormSubmitted)"
                placeholder="Ej: 1"
                min="0"
                formControlName="cus_ben_order">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_order', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_order') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Horario de atención hábil <span class="plan-required">*</span></label>
              <input
                type="text"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_horario_habil', addFormSubmitted)"
                placeholder="Ej: Lunes a Viernes de 08:00 a 18:00"
                formControlName="cus_ben_horario_habil">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_horario_habil', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_horario_habil') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Horario de atención no hábil <span class="plan-required">*</span></label>
              <input
                type="text"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_horario_no_habil', addFormSubmitted)"
                placeholder="Ej: Sábados de 18:00 a 23:00"
                formControlName="cus_ben_horario_no_habil">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_horario_no_habil', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_horario_no_habil') }}
              </div>
            </div>
          </div>
        </div>

        <!-- 2. Contenido del plan: todo opcional -->
        <div class="plan-section">
          <div class="plan-section-header">
            <p class="plan-section-title">
              <span class="plan-section-number">2</span>
              Contenido del plan
              <span class="plan-optional-badge">Opcional</span>
            </p>
          </div>

          <div class="row">
            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">Descripción</label>
              <textarea
                rows="4"
                maxlength="1000"
                class="plan-textarea"
                placeholder="Describe los beneficios y características del plan..."
                formControlName="cus_ben_description"></textarea>
              <div class="plan-counter">
                {{ addPlanForm.get('cus_ben_description')?.value?.length || 0 }}/1000
              </div>
            </div>

            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">
                Texto bienvenida
                <mat-icon title="Si quiere que parte del texto vaya en negrita tiene que estar entre las etiquetas <span></span>">error_outline</mat-icon>
              </label>
              <textarea
                rows="4"
                maxlength="500"
                class="plan-textarea"
                placeholder="Mensaje de bienvenida que verá el beneficiario..."
                formControlName="cus_ben_text_welcome"></textarea>
              <div class="plan-counter">
                {{ addPlanForm.get('cus_ben_text_welcome')?.value?.length || 0 }}/500
              </div>
            </div>

            <div class="col-lg-4 col-12 mb-3">
  <label class="plan-label">Consideraciones del plan</label>

  <textarea
    rows="4"
    maxlength="1000"
    class="plan-textarea"
    placeholder="Consideraciones, reglas o condiciones relevantes del plan..."
    formControlName="cus_ben_text_consideraciones">
  </textarea>

  <div class="plan-counter">
    {{ editPlanForm.get('cus_ben_text_consideraciones')?.value?.length || 0 }}/1000
  </div>
</div>
          </div>
        </div>

        <!-- 3. Precios -->
        <div class="plan-section" *ngIf="isFormSubscription(addPlanForm)">
          <div class="plan-section-header">
            <p class="plan-section-title">
              <span class="plan-section-number">{{ getPlanStepNumber('prices', addPlanForm) }}</span>
              Precios del plan
            </p>
          </div>

          <div class="row">
            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">Precio titular <span class="plan-required">*</span></label>
              <div class="plan-money-input">
                <span class="plan-money-prefix">$</span>
                <input
                  type="number"
                  class="plan-control"
                  [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_price_titular', addFormSubmitted)"
                  placeholder="9990"
                  min="0"
                  formControlName="cus_ben_price_titular">
              </div>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_price_titular', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_price_titular') }}
              </div>
              <div class="plan-help">Valor mensual en pesos chilenos (CLP)</div>
            </div>

            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">Precio primer beneficiario <span class="plan-required">*</span></label>
              <div class="plan-money-input">
                <span class="plan-money-prefix">$</span>
                <input
                  type="number"
                  class="plan-control"
                  [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_price_carga1', addFormSubmitted)"
                  placeholder="6990"
                  min="0"
                  formControlName="cus_ben_price_carga1">
              </div>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_price_carga1', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_price_carga1') }}
              </div>
              <div class="plan-help">Valor mensual en pesos chilenos (CLP)</div>
            </div>

            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">Precio segundo o más beneficiario <span class="plan-required">*</span></label>
              <div class="plan-money-input">
                <span class="plan-money-prefix">$</span>
                <input
                  type="number"
                  class="plan-control"
                  [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_price_carga2', addFormSubmitted)"
                  placeholder="4990"
                  min="0"
                  formControlName="cus_ben_price_carga2">
              </div>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_price_carga2', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_price_carga2') }}
              </div>
              <div class="plan-help">Valor mensual en pesos chilenos (CLP)</div>
            </div>

            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">Fecha de facturación <span class="plan-required">*</span></label>
              <input
                type="date"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_fecha_facturacion', addFormSubmitted)"
                formControlName="cus_ben_fecha_facturacion">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_fecha_facturacion', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_fecha_facturacion') }}
              </div>
              <div class="plan-help">Seleccione la fecha en que se realizará la facturación del plan.</div>
            </div>

            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">Días gratis <span class="plan-required">*</span></label>
              <input
                type="number"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_free_days', addFormSubmitted)"
                min="0"
                formControlName="cus_ben_free_days">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_free_days', addFormSubmitted)">
                {{ getFieldError(addPlanForm, 'cus_ben_free_days') }}
              </div>
              <div class="plan-help">Ingrese la cantidad de días gratis para el plan.</div>
            </div>
          </div>
        </div>

        <!-- Imagen -->
        <div class="plan-section">
          <div class="plan-section-header">
            <p class="plan-section-title">
              <span class="plan-section-number">{{ getPlanStepNumber('image', addPlanForm) }}</span>
              Imagen plan <span class="plan-required">*</span>
            </p>
          </div>

          <div class="row">
            <div class="col-lg-4 col-12 mb-3">
              <div
                class="plan-upload-box"
                [class.plan-box-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_image', addFormSubmitted)">
                <div>
                  <mat-icon class="plan-upload-icon">cloud_upload</mat-icon>
                  <div class="plan-upload-text">Arrastra tu fuente o archivo aquí</div>
                  <div class="plan-upload-subtext">
                    o selecciona un archivo<br>
                    Formatos: JPG, PNG, WEBP máx. 5 MB
                  </div>

                  <label class="plan-upload-button">
                    Examinar
                    <input
                      type="file"
                      accept="image/jpeg,image/png,image/webp"
                      (change)="onFileSelectedLogo($event)">
                  </label>
                </div>
              </div>

              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_image', addFormSubmitted)">
                Debe seleccionar una imagen para el plan.
              </div>
            </div>

            <div class="col-lg-8 col-12 mb-3">
              <div class="plan-file-table plan-image-table">
                <div class="plan-file-table-header plan-image-header">
                  <div>Archivo</div>
                  <div>Tipo</div>
                  <div>Peso</div>
                </div>

                <div class="plan-file-table-row plan-image-header">
                  <ng-container *ngIf="newCustomerBen.cus_ben_image && newCustomerBen.cus_ben_image.name">
                    <div>{{ newCustomerBen.cus_ben_image.name }}</div>
                    <div>{{ newCustomerBen.cus_ben_image.type }}</div>
                    <div>{{ newCustomerBen.cus_ben_image.size / 1024 | number:'1.0-0' }} KB</div>
                  </ng-container>

                  <ng-container *ngIf="!newCustomerBen.cus_ben_image || !newCustomerBen.cus_ben_image.name">
                    <div class="plan-empty-files">
                      <mat-icon>description</mat-icon>
                      No tiene archivos asociados
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Especialidades -->
        <div class="plan-section">
          <div class="plan-section-header">
            <p class="plan-section-title">
              <span class="plan-section-number">{{ getPlanStepNumber('specialities', addPlanForm) }}</span>
              Especialidades <span class="plan-required">*</span>
            </p>

            <button
              type="button"
              class="plan-section-action"
              *ngIf="!showSpecialityForm"
              (click)="showInlineSpecialityForm()">
              <mat-icon>add</mat-icon>
            </button>
          </div>

          <div
            *ngIf="showSpecialityForm"
            class="plan-inline-form mb-3"
            [formGroup]="specialityForm">
            <div class="row">
              <div class="col-lg-3 col-12 mb-3">
                <label class="plan-label">Especialidad <span class="plan-required">*</span></label>
                <select
                  class="plan-select"
                  [class.is-invalid]="isFieldInvalid(specialityForm, 'spe_id', specialityFormSubmitted)"
                  formControlName="spe_id">
                  <option value="">Seleccione especialidad</option>
                  <option
                    *ngFor="let spe of specialityList"
                    [value]="spe.spe_id">
                    {{ spe.spe_name }}
                  </option>
                </select>
                <div
                  class="plan-field-error"
                  *ngIf="isFieldInvalid(specialityForm, 'spe_id', specialityFormSubmitted)">
                  {{ getFieldError(specialityForm, 'spe_id') }}
                </div>
              </div>

              <div class="col-lg-2 col-6 mb-3">
                <label class="plan-label">
                  N° consultas titular
                  <mat-icon title="Si queda vacío se considera ilimitadas.">error_outline</mat-icon>
                </label>
                <input
                  type="number"
                  class="plan-control"
                  placeholder="Ilimitadas"
                  min="0"
                  formControlName="cty_titular">
              </div>

              <div class="col-lg-2 col-6 mb-3">
                <label class="plan-label">Descuento titular % <span class="plan-required">*</span></label>
                <input
                  type="number"
                  class="plan-control"
                  [class.is-invalid]="isFieldInvalid(specialityForm, 'disc_titular', specialityFormSubmitted)"
                  placeholder="100"
                  min="1"
                  max="100"
                  formControlName="disc_titular">
                <div
                  class="plan-field-error"
                  *ngIf="isFieldInvalid(specialityForm, 'disc_titular', specialityFormSubmitted)">
                  {{ getFieldError(specialityForm, 'disc_titular') }}
                </div>
              </div>

              <div class="col-lg-2 col-6 mb-3">
                <label class="plan-label">
                  N° consultas carga
                  <mat-icon title="Si queda vacío se considera ilimitadas.">error_outline</mat-icon>
                </label>
                <input
                  type="number"
                  class="plan-control"
                  placeholder="Ilimitadas"
                  min="0"
                  formControlName="cty_beneficiary">
              </div>

              <div class="col-lg-2 col-6 mb-3">
                <label class="plan-label">Descuento carga % <span class="plan-required">*</span></label>
                <input
                  type="number"
                  class="plan-control"
                  [class.is-invalid]="isFieldInvalid(specialityForm, 'disc_beneficiary', specialityFormSubmitted)"
                  placeholder="100"
                  min="1"
                  max="100"
                  formControlName="disc_beneficiary">
                <div
                  class="plan-field-error"
                  *ngIf="isFieldInvalid(specialityForm, 'disc_beneficiary', specialityFormSubmitted)">
                  {{ getFieldError(specialityForm, 'disc_beneficiary') }}
                </div>
              </div>

              <div class="col-lg-1 col-6 mb-3">
                <label class="plan-label">Orden <span class="plan-required">*</span></label>
                <input
                  type="number"
                  class="plan-control"
                  [class.is-invalid]="isFieldInvalid(specialityForm, 'spe_order', specialityFormSubmitted)"
                  placeholder="Ej: 1"
                  min="0"
                  formControlName="spe_order">
                <div
                  class="plan-field-error"
                  *ngIf="isFieldInvalid(specialityForm, 'spe_order', specialityFormSubmitted)">
                  {{ getFieldError(specialityForm, 'spe_order') }}
                </div>
              </div>
            </div>

            <div class="plan-inline-actions">
              <button
                type="button"
                class="plan-btn-secondary plan-btn-sm"
                (click)="cancelInlineSpecialityForm()">
                Cancelar
              </button>

              <button
                type="button"
                class="plan-btn-primary plan-btn-sm"
                (click)="addInlineSpeciality()">
                Agregar
              </button>
            </div>
          </div>

          <div
            class="plan-file-table"
            [class.plan-table-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_specialities', addFormSubmitted)">
            <div class="plan-file-table-header plan-specialities-header">
              <div>Orden</div>
              <div>Especialidad</div>
              <div>N° Consultas Titular</div>
              <div>N° Consultas Carga</div>
              <div>Acción</div>
            </div>

            <ng-container *ngIf="newCustomerBen.cus_ben_specialities.length < 1">
              <div class="plan-file-table-row">
                <div class="plan-empty-files">
                  <mat-icon>description</mat-icon>
                  No tiene especialidades asociadas
                </div>
              </div>
            </ng-container>

            <ng-container *ngFor="let spe of newCustomerBen.cus_ben_specialities">
              <div class="plan-file-table-row plan-specialities-header">
                <div>{{ spe.spe_order }}</div>
                <div>{{ spe.spe_name }}</div>
                <div>{{ spe.cty_titular !== null && spe.cty_titular !== undefined ? spe.cty_titular : 'Ilimitadas' }} - {{ spe.disc_titular }}%</div>
                <div>{{ spe.cty_beneficiary !== null && spe.cty_beneficiary !== undefined ? spe.cty_beneficiary : 'Ilimitadas' }} - {{ spe.disc_beneficiary }}%</div>
                <div>
                  <button
                    type="button"
                    class="btn btn-sm btn-light"
                    (click)="deleteSpe(spe)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>

          <div
            class="plan-field-error plan-section-validation"
            *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_specialities', addFormSubmitted)">
            Debe agregar al menos una especialidad.
          </div>
        </div>

        <!-- Sala de espera -->
        <div class="plan-section">
          <div class="plan-section-header">
            <p class="plan-section-title">
              <span class="plan-section-number">{{ getPlanStepNumber('waitingRoom', addPlanForm) }}</span>
              Sala de espera <span class="plan-required">*</span>
            </p>

            <button
              type="button"
              class="plan-section-action"
              data-toggle="modal"
              data-target="#addMediaBen"
              (click)="openModalMedia()">
              <mat-icon>add</mat-icon>
            </button>
          </div>

          <div
            class="plan-file-table"
            [class.plan-table-invalid]="isFieldInvalid(addPlanForm, 'cus_ben_media', addFormSubmitted)">
            <div class="plan-file-table-header">
              <div>Archivo</div>
              <div>Tipo</div>
              <div>Peso</div>
              <div>Acción</div>
            </div>

            <ng-container *ngIf="newCustomerBen.cus_ben_media.length < 1">
              <div class="plan-file-table-row">
                <div class="plan-empty-files">
                  <mat-icon>description</mat-icon>
                  No tiene archivos asociados
                </div>
              </div>
            </ng-container>

            <ng-container *ngFor="let media of newCustomerBen.cus_ben_media; let i = index">
              <div class="plan-file-table-row">
                <div>
                  <span *ngIf="media.name">{{ media.name }}</span>
                  <span *ngIf="!media.name">No tiene</span>
                </div>
                <div>
                  <span *ngIf="media.type">{{ media.type }}</span>
                  <span *ngIf="!media.type">No tiene</span>
                </div>
                <div>
                  <span *ngIf="media.size">{{ media.size / 1024 | number:'1.0-0' }} KB</span>
                  <span *ngIf="!media.size">No tiene</span>
                </div>
                <div>
                  <button
                    type="button"
                    class="btn btn-sm btn-light"
                    (click)="deleteMedia(i)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>

          <div
            class="plan-field-error plan-section-validation"
            *ngIf="isFieldInvalid(addPlanForm, 'cus_ben_media', addFormSubmitted)">
            Debe agregar al menos un archivo para la sala de espera.
          </div>
        </div>
      </div>
    </div>

    <div class="plan-footer-actions">
      <button
        type="button"
        class="plan-btn-secondary"
        (click)="cancelAdd()">
        Cancelar
      </button>

      <button
        type="submit"
        class="plan-btn-primary">
        Agregar
      </button>
    </div>
  </form>
</div>

<!-- ===================================================== -->
<!-- EDITAR PLAN -->
<!-- ===================================================== -->
<div *ngIf="steps.edit" class="plan-form-wrapper">
  <form [formGroup]="editPlanForm" (ngSubmit)="confirmEdit()" novalidate>
    <div class="plan-form-content">
      <div class="plan-form-main">
        <div class="plan-form-title-box">
          <h2 class="plan-form-title">Edición de plan</h2>
          <p class="plan-form-subtitle">
            Los campos marcados con <span class="plan-required">*</span> son obligatorios.
          </p>
        </div>

        <!-- 1. Información general -->
        <div class="plan-section">
          <div class="plan-section-header">
            <p class="plan-section-title">
              <span class="plan-section-number">1</span>
              Información general
            </p>
          </div>

          <div class="row">
            <div class="col-lg-3 col-12 mb-3">
              <label class="plan-label">Nombre <span class="plan-required">*</span></label>
              <input
                type="text"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_name', editFormSubmitted)"
                placeholder="Ej: Plan Familiar Telemedicina"
                formControlName="cus_ben_name">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_name', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_name') }}
              </div>
            </div>

            <div class="col-lg-3 col-12 mb-3">
              <label class="plan-label">Cliente <span class="plan-required">*</span></label>
              <select
                class="plan-select"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_cus_id', editFormSubmitted)"
                formControlName="cus_ben_cus_id">
                <option value="">Seleccione cliente</option>
                <option
                  *ngFor="let customer of customers"
                  [value]="customer.cus_id">
                  {{ customer.cus_name }}
                </option>
              </select>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_cus_id', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_cus_id') }}
              </div>
            </div>

            <div class="col-lg-3 col-12 mb-3">
              <label class="plan-label">Periodicidad <span class="plan-required">*</span></label>
              <select
                class="plan-select"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_cus_ben_typ_id', editFormSubmitted)"
                formControlName="cus_ben_cus_ben_typ_id">
                <option value="">Seleccione periodicidad</option>
                <option
                  *ngFor="let benType of cBenefitsTypes"
                  [value]="benType.cus_ben_typ_id">
                  {{ benType.cus_ben_typ_name }}
                </option>
              </select>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_cus_ben_typ_id', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_cus_ben_typ_id') }}
              </div>
            </div>

            <div class="col-lg-3 col-12 mb-3">
              <label class="plan-label">Suscripción <span class="plan-required">*</span></label>
              <select
                class="plan-select"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_is_suscription', editFormSubmitted)"
                formControlName="cus_ben_is_suscription">
                <option [ngValue]="null">Seleccione opción</option>
                <option [ngValue]="true">Sí</option>
                <option [ngValue]="false">No</option>
              </select>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_is_suscription', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_is_suscription') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Tipo <span class="plan-required">*</span></label>
              <select
                class="plan-select"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_particular', editFormSubmitted)"
                formControlName="cus_ben_particular">
                <option [ngValue]="null">Seleccione tipo</option>
                <option [ngValue]="true">Particular</option>
                <option [ngValue]="false">Empresarial</option>
              </select>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_particular', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_particular') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">
                N° cargas <span class="plan-required">*</span>
                <mat-icon title="Ingrese 0 si el plan no permite cargas.">error_outline</mat-icon>
              </label>
              <input
                type="number"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_qty_beneficiaries', editFormSubmitted)"
                placeholder="Ej: 2"
                min="0"
                formControlName="cus_ben_qty_beneficiaries">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_qty_beneficiaries', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_qty_beneficiaries') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Código <span class="plan-required">*</span></label>
              <input
                type="text"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_code', editFormSubmitted)"
                placeholder="Ej: PTD001"
                formControlName="cus_ben_code">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_code', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_code') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Teléfono <span class="plan-required">*</span></label>
              <input
                type="text"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_phone', editFormSubmitted)"
                placeholder="Ej: +56 9 1234 5678"
                formControlName="cus_ben_phone">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_phone', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_phone') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Base informada <span class="plan-required">*</span></label>
              <select
                class="plan-select"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_base_informada', editFormSubmitted)"
                formControlName="cus_ben_base_informada">
                <option [ngValue]="null">Seleccione opción</option>
                <option [ngValue]="true">Sí</option>
                <option [ngValue]="false">No</option>
              </select>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_base_informada', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_base_informada') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Email <span class="plan-required">*</span></label>
              <input
                type="email"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_mail_contact', editFormSubmitted)"
                placeholder="plan@almamedis.cl"
                formControlName="cus_ben_mail_contact">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_mail_contact', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_mail_contact') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">
                Orden <span class="plan-required">*</span>
                <mat-icon title="Número de orden del plan">error_outline</mat-icon>
              </label>
              <input
                type="number"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_order', editFormSubmitted)"
                placeholder="Ej: 1"
                min="0"
                formControlName="cus_ben_order">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_order', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_order') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Horario de atención hábil <span class="plan-required">*</span></label>
              <input
                type="text"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_horario_habil', editFormSubmitted)"
                placeholder="Ej: 08:00 a 18:00"
                formControlName="cus_ben_horario_habil">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_horario_habil', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_horario_habil') }}
              </div>
            </div>

            <div class="col-lg-3 col-6 mb-3">
              <label class="plan-label">Horario de atención no hábil <span class="plan-required">*</span></label>
              <input
                type="text"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_horario_no_habil', editFormSubmitted)"
                placeholder="Ej: 18:00 a 23:00"
                formControlName="cus_ben_horario_no_habil">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_horario_no_habil', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_horario_no_habil') }}
              </div>
            </div>
          </div>
        </div>

        <!-- 2. Contenido opcional -->
        <div class="plan-section">
          <div class="plan-section-header">
            <p class="plan-section-title">
              <span class="plan-section-number">2</span>
              Contenido del plan
              <span class="plan-optional-badge">Opcional</span>
            </p>
          </div>

          <div class="row">
            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">Descripción</label>
              <textarea
                rows="4"
                maxlength="1000"
                class="plan-textarea"
                placeholder="Describe los beneficios y características del plan..."
                formControlName="cus_ben_description"></textarea>
              <div class="plan-counter">
                {{ editPlanForm.get('cus_ben_description')?.value?.length || 0 }}/1000
              </div>
            </div>

            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">
                Texto bienvenida
                <mat-icon title="Si quiere que parte del texto vaya en negrita tiene que estar entre las etiquetas <span></span>">error_outline</mat-icon>
              </label>
              <textarea
                rows="4"
                maxlength="500"
                class="plan-textarea"
                placeholder="Mensaje de bienvenida que verá el beneficiario..."
                formControlName="cus_ben_text_welcome"></textarea>
              <div class="plan-counter">
                {{ editPlanForm.get('cus_ben_text_welcome')?.value?.length || 0 }}/500
              </div>
            </div>

            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">Consideraciones del plan</label>
              <textarea
                rows="4"
                maxlength="1000"
                class="plan-textarea"
                placeholder="Consideraciones, reglas o condiciones relevantes del plan..."
                formControlName="cus_ben_text_consideraciones"></textarea>
              <div class="plan-counter">
                {{ editPlanForm.get('cus_ben_text_consideraciones')?.value?.length || 0 }}/1000
              </div>
            </div>
          </div>
        </div>

        <!-- 3. Precios -->
        <div class="plan-section" *ngIf="isFormSubscription(editPlanForm)">
          <div class="plan-section-header">
            <p class="plan-section-title">
              <span class="plan-section-number">{{ getPlanStepNumber('prices', editPlanForm) }}</span>
              Precios del plan
            </p>
          </div>

          <div class="row">
            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">Precio titular <span class="plan-required">*</span></label>
              <div class="plan-money-input">
                <span class="plan-money-prefix">$</span>
                <input
                  type="number"
                  class="plan-control"
                  [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_price_titular', editFormSubmitted)"
                  placeholder="9990"
                  min="0"
                  formControlName="cus_ben_price_titular">
              </div>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_price_titular', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_price_titular') }}
              </div>
              <div class="plan-help">Valor mensual en pesos chilenos (CLP)</div>
            </div>

            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">Precio primer beneficiario <span class="plan-required">*</span></label>
              <div class="plan-money-input">
                <span class="plan-money-prefix">$</span>
                <input
                  type="number"
                  class="plan-control"
                  [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_price_carga1', editFormSubmitted)"
                  placeholder="6990"
                  min="0"
                  formControlName="cus_ben_price_carga1">
              </div>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_price_carga1', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_price_carga1') }}
              </div>
              <div class="plan-help">Valor mensual en pesos chilenos (CLP)</div>
            </div>

            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">Precio segundo o más beneficiario <span class="plan-required">*</span></label>
              <div class="plan-money-input">
                <span class="plan-money-prefix">$</span>
                <input
                  type="number"
                  class="plan-control"
                  [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_price_carga2', editFormSubmitted)"
                  placeholder="4990"
                  min="0"
                  formControlName="cus_ben_price_carga2">
              </div>
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_price_carga2', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_price_carga2') }}
              </div>
              <div class="plan-help">Valor mensual en pesos chilenos (CLP)</div>
            </div>

            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">Fecha de facturación <span class="plan-required">*</span></label>
              <input
                type="date"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_fecha_facturacion', editFormSubmitted)"
                formControlName="cus_ben_fecha_facturacion">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_fecha_facturacion', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_fecha_facturacion') }}
              </div>
              <div class="plan-help">Seleccione la fecha en que se realizará la facturación del plan.</div>
            </div>

            <div class="col-lg-4 col-12 mb-3">
              <label class="plan-label">Días gratis <span class="plan-required">*</span></label>
              <input
                type="number"
                class="plan-control"
                [class.is-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_free_days', editFormSubmitted)"
                min="0"
                formControlName="cus_ben_free_days">
              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_free_days', editFormSubmitted)">
                {{ getFieldError(editPlanForm, 'cus_ben_free_days') }}
              </div>
              <div class="plan-help">Ingrese la cantidad de días gratis para el plan.</div>
            </div>
          </div>
        </div>

        <!-- Imagen -->
        <div class="plan-section">
          <div class="plan-section-header">
            <p class="plan-section-title">
              <span class="plan-section-number">{{ getPlanStepNumber('image', editPlanForm) }}</span>
              Imagen plan <span class="plan-required">*</span>
            </p>
          </div>

          <div class="row">
            <div class="col-lg-4 col-12 mb-3">
              <div
                class="plan-upload-box"
                [class.plan-box-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_image', editFormSubmitted)">
                <div>
                  <mat-icon class="plan-upload-icon">cloud_upload</mat-icon>
                  <div class="plan-upload-text">Arrastra tu fuente o archivo aquí</div>
                  <div class="plan-upload-subtext">
                    o selecciona un archivo<br>
                    Formatos: JPG, PNG, WEBP máx. 5 MB
                  </div>

                  <label class="plan-upload-button">
                    Examinar
                    <input
                      type="file"
                      accept="image/jpeg,image/png,image/webp"
                      (change)="onFileSelectedLogo($event)">
                  </label>
                </div>
              </div>

              <div
                class="plan-field-error"
                *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_image', editFormSubmitted)">
                Debe seleccionar una imagen para el plan.
              </div>
            </div>

            <div class="col-lg-8 col-12 mb-3">
              <div class="plan-file-table plan-image-table">
                <div class="plan-file-table-header plan-image-header">
                  <div>Archivo</div>
                  <div>Tipo</div>
                  <div>Peso</div>
                </div>

                <div class="plan-file-table-row plan-image-header">
                  <ng-container *ngIf="editCustomerBenSelected.cus_ben_image && editCustomerBenSelected.cus_ben_image.name">
                    <div>{{ editCustomerBenSelected.cus_ben_image.name }}</div>
                    <div>{{ editCustomerBenSelected.cus_ben_image.type }}</div>
                    <div>{{ editCustomerBenSelected.cus_ben_image.size / 1024 | number:'1.0-0' }} KB</div>
                  </ng-container>

                  <ng-container *ngIf="editCustomerBenSelected.cus_ben_image && !editCustomerBenSelected.cus_ben_image.name">
                    <div>
                      <a [href]="editCustomerBenSelected.cus_ben_image" target="_blank">Ver imagen actual</a>
                    </div>
                    <div>Imagen</div>
                    <div>—</div>
                  </ng-container>

                  <ng-container *ngIf="!editCustomerBenSelected.cus_ben_image">
                    <div class="plan-empty-files">
                      <mat-icon>description</mat-icon>
                      No tiene archivos asociados
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Especialidades -->
        <div class="plan-section">
          <div class="plan-section-header">
            <p class="plan-section-title">
              <span class="plan-section-number">{{ getPlanStepNumber('specialities', editPlanForm) }}</span>
              Especialidades <span class="plan-required">*</span>
            </p>

            <button
              type="button"
              class="plan-section-action"
              *ngIf="!showSpecialityForm"
              (click)="showInlineSpecialityForm()">
              <mat-icon>add</mat-icon>
            </button>
          </div>

          <div
            *ngIf="showSpecialityForm"
            class="plan-inline-form mb-3"
            [formGroup]="specialityForm">
            <div class="row">
              <div class="col-lg-3 col-12 mb-3">
                <label class="plan-label">Especialidad <span class="plan-required">*</span></label>
                <select
                  class="plan-select"
                  [class.is-invalid]="isFieldInvalid(specialityForm, 'spe_id', specialityFormSubmitted)"
                  formControlName="spe_id">
                  <option value="">Seleccione especialidad</option>
                  <option
                    *ngFor="let spe of specialityList"
                    [value]="spe.spe_id">
                    {{ spe.spe_name }}
                  </option>
                </select>
                <div
                  class="plan-field-error"
                  *ngIf="isFieldInvalid(specialityForm, 'spe_id', specialityFormSubmitted)">
                  {{ getFieldError(specialityForm, 'spe_id') }}
                </div>
              </div>

              <div class="col-lg-2 col-6 mb-3">
                <label class="plan-label">
                  N° consultas titular
                  <mat-icon title="Si queda vacío se considera ilimitadas.">error_outline</mat-icon>
                </label>
                <input
                  type="number"
                  class="plan-control"
                  placeholder="Ilimitadas"
                  min="0"
                  formControlName="cty_titular">
              </div>

              <div class="col-lg-2 col-6 mb-3">
                <label class="plan-label">Descuento titular % <span class="plan-required">*</span></label>
                <input
                  type="number"
                  class="plan-control"
                  [class.is-invalid]="isFieldInvalid(specialityForm, 'disc_titular', specialityFormSubmitted)"
                  placeholder="100"
                  min="1"
                  max="100"
                  formControlName="disc_titular">
                <div
                  class="plan-field-error"
                  *ngIf="isFieldInvalid(specialityForm, 'disc_titular', specialityFormSubmitted)">
                  {{ getFieldError(specialityForm, 'disc_titular') }}
                </div>
              </div>

              <div class="col-lg-2 col-6 mb-3">
                <label class="plan-label">
                  N° consultas carga
                  <mat-icon title="Si queda vacío se considera ilimitadas.">error_outline</mat-icon>
                </label>
                <input
                  type="number"
                  class="plan-control"
                  placeholder="Ilimitadas"
                  min="0"
                  formControlName="cty_beneficiary">
              </div>

              <div class="col-lg-2 col-6 mb-3">
                <label class="plan-label">Descuento carga % <span class="plan-required">*</span></label>
                <input
                  type="number"
                  class="plan-control"
                  [class.is-invalid]="isFieldInvalid(specialityForm, 'disc_beneficiary', specialityFormSubmitted)"
                  placeholder="100"
                  min="1"
                  max="100"
                  formControlName="disc_beneficiary">
                <div
                  class="plan-field-error"
                  *ngIf="isFieldInvalid(specialityForm, 'disc_beneficiary', specialityFormSubmitted)">
                  {{ getFieldError(specialityForm, 'disc_beneficiary') }}
                </div>
              </div>

              <div class="col-lg-1 col-6 mb-3">
                <label class="plan-label">Orden <span class="plan-required">*</span></label>
                <input
                  type="number"
                  class="plan-control"
                  [class.is-invalid]="isFieldInvalid(specialityForm, 'spe_order', specialityFormSubmitted)"
                  placeholder="Ej: 1"
                  min="0"
                  formControlName="spe_order">
                <div
                  class="plan-field-error"
                  *ngIf="isFieldInvalid(specialityForm, 'spe_order', specialityFormSubmitted)">
                  {{ getFieldError(specialityForm, 'spe_order') }}
                </div>
              </div>
            </div>

            <div class="plan-inline-actions">
              <button
                type="button"
                class="plan-btn-secondary plan-btn-sm"
                (click)="cancelInlineSpecialityForm()">
                Cancelar
              </button>

              <button
                type="button"
                class="plan-btn-primary plan-btn-sm"
                (click)="addInlineSpeciality()">
                Agregar
              </button>
            </div>
          </div>

          <div
            class="plan-file-table"
            [class.plan-table-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_specialities', editFormSubmitted)">
            <div class="plan-file-table-header plan-specialities-header">
              <div>Orden</div>
              <div>Especialidad</div>
              <div>N° Consultas Titular</div>
              <div>N° Consultas Carga</div>
              <div>Acción</div>
            </div>

            <ng-container *ngIf="editCustomerBenSelected.cus_ben_specialities.length < 1 && editCustomerBenSelected.new_cus_ben_specialities.length < 1">
              <div class="plan-file-table-row">
                <div class="plan-empty-files">
                  <mat-icon>description</mat-icon>
                  No tiene especialidades asociadas
                </div>
              </div>
            </ng-container>

            <ng-container *ngFor="let spe of editCustomerBenSelected.cus_ben_specialities">
              <div class="plan-file-table-row plan-specialities-header">
                <div>
                  <input
                    type="number"
                    class="plan-control"
                    placeholder="Ej: 1"
                    min="0"
                    [value]="spe.spe_order"
                    (input)="updateExistingSpecialityOrder(spe, $event)">
                </div>
                <div>{{ spe.spe_name }}</div>
                <div>
                  {{ spe.cus_ben_qty_con_titular ? spe.cus_ben_qty_con_titular : 'Ilimitadas' }} -
                  {{ spe.cus_ben_disc_titular }}%
                </div>
                <div>
                  {{ spe.cus_ben_qty_con_beneficiaries ? spe.cus_ben_qty_con_beneficiaries : 'Ilimitadas' }} -
                  {{ spe.cus_ben_disc_beneficiaries }}%
                </div>
                <div>
                  <button
                    type="button"
                    class="btn btn-sm btn-light"
                    (click)="deleteSpeDet(spe.cus_ben_det_id)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>

            <ng-container *ngFor="let spe of editCustomerBenSelected.new_cus_ben_specialities">
              <div class="plan-file-table-row plan-specialities-header">
                <div>
                  <input
                    type="number"
                    class="plan-control"
                    placeholder="Ej: 1"
                    min="0"
                    [value]="spe.spe_order"
                    (input)="updateNewSpecialityOrder(spe, $event)">
                </div>
                <div>{{ spe.spe_name }}</div>
                <div>{{ spe.cty_titular !== null && spe.cty_titular !== undefined ? spe.cty_titular : 'Ilimitadas' }} - {{ spe.disc_titular }}%</div>
                <div>{{ spe.cty_beneficiary !== null && spe.cty_beneficiary !== undefined ? spe.cty_beneficiary : 'Ilimitadas' }} - {{ spe.disc_beneficiary }}%</div>
                <div>
                  <button
                    type="button"
                    class="btn btn-sm btn-light"
                    (click)="deleteSpe(spe)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>

          <div
            class="plan-field-error plan-section-validation"
            *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_specialities', editFormSubmitted)">
            Debe existir al menos una especialidad asociada.
          </div>
        </div>

        <!-- Sala de espera -->
        <div class="plan-section">
          <div class="plan-section-header">
            <p class="plan-section-title">
              <span class="plan-section-number">{{ getPlanStepNumber('waitingRoom', editPlanForm) }}</span>
              Sala de espera <span class="plan-required">*</span>
            </p>

            <button
              type="button"
              class="plan-section-action"
              data-toggle="modal"
              data-target="#addMediaBen"
              (click)="openModalMedia()">
              <mat-icon>add</mat-icon>
            </button>
          </div>

          <div
            class="plan-file-table"
            [class.plan-table-invalid]="isFieldInvalid(editPlanForm, 'cus_ben_media', editFormSubmitted)">
            <div class="plan-file-table-header">
              <div>Archivo</div>
              <div>Tipo</div>
              <div>Peso</div>
              <div>Acción</div>
            </div>

            <ng-container *ngIf="editCustomerBenSelected.cus_ben_media.length < 1 && editCustomerBenSelected.new_cus_ben_media.length < 1">
              <div class="plan-file-table-row">
                <div class="plan-empty-files">
                  <mat-icon>description</mat-icon>
                  No tiene archivos asociados
                </div>
              </div>
            </ng-container>

            <ng-container *ngFor="let media of editCustomerBenSelected.cus_ben_media; let i = index">
              <div class="plan-file-table-row">
                <div>
                  <a *ngIf="media.med_roo_lob_url" [href]="media.med_roo_lob_url" target="_blank">Ver</a>
                  <span *ngIf="!media.med_roo_lob_url">No tiene</span>
                </div>
                <div>
                  <span *ngIf="media.med_roo_lob_media_type">{{ media.med_roo_lob_media_type }}</span>
                  <span *ngIf="!media.med_roo_lob_media_type">No tiene</span>
                </div>
                <div>
                  <span *ngIf="media.size">{{ media.size / 1024 | number:'1.0-0' }} KB</span>
                  <span *ngIf="!media.size">No tiene</span>
                </div>
                <div>
                  <button
                    type="button"
                    class="btn btn-sm btn-light"
                    (click)="deleteMediaRoomLobby(media.med_roo_lob_id)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>

            <ng-container *ngFor="let media of editCustomerBenSelected.new_cus_ben_media; let i = index">
              <div class="plan-file-table-row">
                <div>
                  <span *ngIf="media.name">{{ media.name }}</span>
                  <span *ngIf="!media.name">No tiene</span>
                </div>
                <div>
                  <span *ngIf="media.type">{{ media.type }}</span>
                  <span *ngIf="!media.type">No tiene</span>
                </div>
                <div>
                  <span *ngIf="media.size">{{ media.size / 1024 | number:'1.0-0' }} KB</span>
                  <span *ngIf="!media.size">No tiene</span>
                </div>
                <div>
                  <button
                    type="button"
                    class="btn btn-sm btn-light"
                    (click)="deleteMedia(i)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>

          <div
            class="plan-field-error plan-section-validation"
            *ngIf="isFieldInvalid(editPlanForm, 'cus_ben_media', editFormSubmitted)">
            Debe existir al menos un archivo para la sala de espera.
          </div>
        </div>
      </div>
    </div>

    <div class="plan-footer-actions">
      <button
        type="button"
        class="plan-btn-secondary"
        (click)="cancelEdit()">
        Cancelar
      </button>

      <button
        type="submit"
        class="plan-btn-primary">
        Editar
      </button>
    </div>
  </form>
</div>

<!-- ===================================================== -->
<!-- MODAL ELIMINAR -->
<!-- ===================================================== -->
<div
  class="modal fade hide"
  id="deleteCustomerBen"
  tabindex="-1"
  role="dialog"
  aria-labelledby="deleteCustomerBen"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-center">
        <h2 class="pModalTitle">Borrar cliente</h2>
      </div>

      <div class="modal-body">
        <div class="row modalBody" style="width: 100%;">
          <p class="pTableTitle">
            ¿Está seguro de eliminar el plan {{ deleteCustomerBenSelected.cus_ben_name }}?
          </p>
          <p>Todos los beneficiarios asociados a este plan se deshabilitarán.</p>
        </div>

        <div class="row modalBody" style="width: 100%;">
          <div class="col-md-6 modalBody">
            <button
              class="primary buttonStyleSecondary"
              data-toggle="modal"
              data-target="#deleteCustomerBen">
              Cancelar
            </button>
          </div>

          <div class="col-md-6 modalBody">
            <button
              class="primary buttonStylePrimary"
              (click)="confirmDelete()">
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ===================================================== -->
<!-- MODAL DETALLE -->
<!-- ===================================================== -->
<div
  class="modal fade hide"
  id="seeCustomerBen"
  tabindex="-1"
  role="dialog"
  aria-labelledby="seeCustomerBen"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-center">
        <h2 class="pModalTitle">Detalle Plan</h2>
      </div>

      <div class="modal-body">
        <div class="row modalBody" style="width: 100%;">
          <div class="row" style="width: 100%;">
            <div class="col-6">
              <p class="pTableTitle">Imagen</p>
              <ng-container *ngIf="detailCustomerBenSelected.cus_ben_image">
                <img [src]="detailCustomerBenSelected.cus_ben_image" width="90%">
              </ng-container>
              <ng-container *ngIf="!detailCustomerBenSelected.cus_ben_image">
                <p class="pTableNotInfo">No tiene imagen</p>
              </ng-container>
            </div>

            <div class="col-3">
              <p class="pTableTitle">Plan</p>
              <ng-container *ngIf="detailCustomerBenSelected.cus_ben_name">
                <p class="pTableInfo">{{ detailCustomerBenSelected.cus_ben_name }}</p>
              </ng-container>
              <ng-container *ngIf="!detailCustomerBenSelected.cus_ben_name">
                <p class="pTableNotInfo">No tiene</p>
              </ng-container>
            </div>

            <div class="col-3">
              <p class="pTableTitle">Cliente</p>
              <ng-container *ngIf="detailCustomerBenSelected.cus_name">
                <p class="pTableInfo">{{ detailCustomerBenSelected.cus_name }}</p>
              </ng-container>
              <ng-container *ngIf="!detailCustomerBenSelected.cus_name">
                <p class="pTableNotInfo">No tiene</p>
              </ng-container>
            </div>

            <div class="col-12"><hr></div>

            <div class="col-6">
              <p class="pTableTitle">Teléfono</p>
              <ng-container *ngIf="detailCustomerBenSelected.cus_ben_phone">
                <p class="pTableInfo">{{ detailCustomerBenSelected.cus_ben_phone }}</p>
              </ng-container>
              <ng-container *ngIf="!detailCustomerBenSelected.cus_ben_phone">
                <p class="pTableNotInfo">No tiene</p>
              </ng-container>
            </div>

            <div class="col-6">
              <p class="pTableTitle">Periodicidad</p>
              <ng-container *ngIf="detailCustomerBenSelected.cus_ben_typ_name">
                <p class="pTableInfo">{{ detailCustomerBenSelected.cus_ben_typ_name }}</p>
              </ng-container>
              <ng-container *ngIf="!detailCustomerBenSelected.cus_ben_typ_name">
                <p class="pTableNotInfo">No tiene</p>
              </ng-container>
            </div>

            <div class="col-12"><hr></div>

            <div class="col-6">
              <p class="pTableTitle">N° Cargas</p>
              <ng-container *ngIf="detailCustomerBenSelected.cus_ben_qty_beneficiaries !== null && detailCustomerBenSelected.cus_ben_qty_beneficiaries !== undefined && detailCustomerBenSelected.cus_ben_qty_beneficiaries !== ''">
                <p class="pTableInfo">{{ detailCustomerBenSelected.cus_ben_qty_beneficiaries }}</p>
              </ng-container>
              <ng-container *ngIf="detailCustomerBenSelected.cus_ben_qty_beneficiaries === null || detailCustomerBenSelected.cus_ben_qty_beneficiaries === undefined || detailCustomerBenSelected.cus_ben_qty_beneficiaries === ''">
                <p class="pTableNotInfo">Por base</p>
              </ng-container>
            </div>

            <div class="col-6">
              <p class="pTableTitle">Tipo</p>
              <ng-container *ngIf="detailCustomerBenSelected.cus_ben_particular">
                <p class="pTableInfo">Particular</p>
              </ng-container>
              <ng-container *ngIf="!detailCustomerBenSelected.cus_ben_particular">
                <p class="pTableNotInfo">Empresarial</p>
              </ng-container>
            </div>

            <div class="col-12"><hr></div>

            <div class="col-6">
              <p class="pTableTitle">C. Consultas</p>
              <ng-container *ngFor="let especialidad of detailCustomerBenSelected.cus_ben_specialities">
                <p class="pSpecialities">{{ especialidad.spe_name }}:</p>
                <ul>
                  <li>
                    Titular:
                    <ng-container *ngIf="!especialidad.cus_ben_qty_con_titular">Ilimitadas</ng-container>
                    <ng-container *ngIf="especialidad.cus_ben_qty_con_titular">
                      {{ especialidad.cus_ben_qty_con_titular }}
                    </ng-container>
                  </li>
                  <li>
                    Carga:
                    <ng-container *ngIf="!especialidad.cus_ben_qty_con_beneficiaries">Ilimitadas</ng-container>
                    <ng-container *ngIf="especialidad.cus_ben_qty_con_beneficiaries">
                      {{ especialidad.cus_ben_qty_con_beneficiaries }}
                    </ng-container>
                  </li>
                </ul>
              </ng-container>
            </div>

            <div class="col-6">
              <p class="pTableTitle">Sala de espera</p>
              <ng-container *ngFor="let mediaElement of detailCustomerBenSelected.cus_ben_media">
                <p class="pSpecialities">
                  <a [href]="mediaElement.med_roo_lob_url" target="_blank">
                    {{ mediaElement.med_roo_lob_media_type == 'image' ? 'Imagen' : 'Video' }}
                  </a>
                </p>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="row" style="justify-content: space-around;">
          <div class="col-xs-12" style="text-align: -webkit-center;">
            <button
              type="button"
              class="buttonStyleSecondary"
              data-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ===================================================== -->
<!-- MODAL MEDIA -->
<!-- ===================================================== -->
<div
  class="modal fade hide"
  id="addMediaBen"
  tabindex="-1"
  role="dialog"
  aria-labelledby="addMediaBen"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-center">
        <h2 class="pModalTitle">Agregar media</h2>
      </div>

      <div class="modal-body">
        <div class="row modalBody" style="width: 100%; margin-bottom: 20px;">
          <div class="col-4">
            <label class="buttonStyleSecondary" style="height: 40px;">
              Examinar
              <input
                type="file"
                style="cursor: pointer !important;"
                (change)="addMedia($event)">
            </label>
            <p *ngIf="newMedia.name">{{ newMedia.name }}</p>
          </div>
        </div>

        <div class="row modalBody" style="width: 100%;">
          <div class="col-md-6 modalBody">
            <button
              type="button"
              class="buttonStyleSecondary"
              data-dismiss="modal">
              Cerrar
            </button>
          </div>

          <div class="col-md-6 modalBody">
            <button
              type="button"
              class="primary buttonStylePrimary"
              [attr.data-dismiss]="newMedia && newMedia.name ? 'modal' : null"
              (click)="confirmAddMedia()">
              Agregar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<button
  #deleteCustomerBenTri
  type="button"
  class="btn d-none"
  data-toggle="modal"
  data-target="#deleteCustomerBen">
</button>

<button
  #seeCustomerBenTri
  type="button"
  class="btn d-none"
  data-toggle="modal"
  data-target="#seeCustomerBen">
</button>

